module.exports = __webpack_public_path__ + "app/principal/modals/modal-legal-entity-readable-import-2r6Wrxsx.html";